import { staticPageStyles } from '@aboutyou/legacy-shared'
import React from 'react'
import styled from 'styled-components'

interface ITextProps {
  htmlContent: string
}

const StyledTextContainer = styled.div`
  ul {
    li {
      padding: 0 0 0 36px;
      position: relative;
      margin: 10px 0;

      &::before {
        content: '•';
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  ol {
    padding: 0 0 0 20px;

    li {
      padding: 0 0 0 20px;
      margin: 5px 0;
    }
  }
  ${staticPageStyles}
`

const Text: React.FunctionComponent<ITextProps> = ({ htmlContent }) => {
  return (
    <StyledTextContainer dangerouslySetInnerHTML={{ __html: htmlContent }} />
  )
}

export default Text
